(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reality-hero-duo"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
      function init(root) {
        const sectionRoot = root.closest('.shopify-section');
        const track = root.querySelector('.rhd-track');
        const slides = $$('.rhd-slide', root);
        const dots = $$('.rhd-dot', root);
        if (!track || !slides.length) return;
        const mqlDesktop = matchMedia('(min-width: 750px)');
        const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
        const autoplay = track.dataset.autoplay === 'true' && !reduce && slides.length > 1;
        const interval = parseInt(track.dataset.interval || '6000', 10);
        const adaptDesktop = root.classList.contains('rhd--is-adapt');
        const adaptMobile = root.classList.contains('rhd--is-adapt-mobile');
        let i = 0,
          t = null;
        const ratioPercentFromSlide = (slide) => {
          const arD = parseFloat(slide.getAttribute('data-ar-desktop'));
          const arM = parseFloat(slide.getAttribute('data-ar-mobile'));
          const ar = mqlDesktop.matches ? arD : isNaN(arM) ? arD : arM;
          return isFinite(ar) && ar > 0 ? 100 / ar : null;
        };
        const applyActiveRatio = (idx) => {
          if (!sectionRoot) return;
          const adapt = mqlDesktop.matches ? adaptDesktop : adaptMobile;
          if (!adapt) return;
          const p = ratioPercentFromSlide(slides[idx]);
          if (p != null) {
            sectionRoot.style.setProperty('--image-ratio-percent', p + '%');
          }
        };
        const go = (n) => {
          const next = (n + slides.length) % slides.length;
          slides[i].classList.remove('is-active');
          slides[i].setAttribute('aria-hidden', 'true');
          slides[next].classList.add('is-active');
          slides[next].setAttribute('aria-hidden', 'false');
          if (dots.length) {
            dots[i].removeAttribute('aria-current');
            dots[next].setAttribute('aria-current', 'true');
          }
          i = next;
          applyActiveRatio(i);
        };
        const stop = () => {
          if (t) {
            clearInterval(t);
            t = null;
          }
        };
        const play = () => {
          stop();
          if (autoplay) {
            t = setInterval(() => go(i + 1), interval);
          }
        };
        dots.forEach((btn) =>
          btn.addEventListener('click', () => {
            stop();
            go(parseInt(btn.dataset.go || '0', 10));
          })
        );
        document.addEventListener('visibilitychange', () => (document.hidden ? stop() : play()));
        mqlDesktop.addEventListener('change', () => applyActiveRatio(i));
        addEventListener('resize', () => applyActiveRatio(i));
        applyActiveRatio(0);
        play();
      }
      function initAll() {
        $$('.rhd-hero').forEach(init);
      }
      document.addEventListener('DOMContentLoaded', initAll);
      document.addEventListener('shopify:section:load', (e) => {
        const root = e.target.querySelector('.rhd-hero');
        if (root) init(root);
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rlt-hero-split"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
      function init(root) {
        const sectionRoot = root.closest('.shopify-section');
        const track = root.querySelector('.rh-hero__track');
        const slides = $$('.rh-hero__slide, .rhd-slide', root);
        const dots = $$('.rh-hero__dot', root);
        const toggle = root.querySelector('.rh-hero__toggle');
        if (!track || !slides.length) return;
        const mqlDesktop = matchMedia('(min-width: 750px)');
        const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
        let i = 0,
          t = null;
        const autoplay = track.dataset.autoplay === 'true' && !reduce && slides.length > 1;
        const interval = parseInt(track.dataset.interval || '6000', 10);
        const adaptDesktop = root.classList.contains('rh-hero--is-adapt');
        const adaptMobile = root.classList.contains('rh-hero--is-adapt-mobile');
        const ratioPercentFromSlide = (slide) => {
          const arDesktop = parseFloat(slide.getAttribute('data-ar-desktop'));
          const arMobile = parseFloat(slide.getAttribute('data-ar-mobile'));
          const ar = mqlDesktop.matches ? arDesktop : isNaN(arMobile) ? arDesktop : arMobile;
          return isFinite(ar) && ar > 0 ? 100 / ar : null;
        };
        const applyActiveRatio = (idx) => {
          if (!sectionRoot) return;
          const adapt = mqlDesktop.matches ? adaptDesktop : adaptMobile;
          if (!adapt) return;
          const percent = ratioPercentFromSlide(slides[idx]);
          if (percent != null) sectionRoot.style.setProperty('--rlt-hero-ratio-percent', percent + '%');
        };
        const go = (n) => {
          const next = (n + slides.length) % slides.length;
          slides[i].classList.remove('is-active');
          slides[i].setAttribute('aria-hidden', 'true');
          slides[next].classList.add('is-active');
          slides[next].setAttribute('aria-hidden', 'false');
          if (dots.length) {
            dots[i].removeAttribute('aria-current');
            dots[next].setAttribute('aria-current', 'true');
          }
          i = next;
          applyActiveRatio(i);
        };
        const stop = () => {
          if (t) {
            clearInterval(t);
            t = null;
          }
        };
        const play = () => {
          stop();
          if (autoplay) {
            t = setInterval(() => go(i + 1), interval);
          }
        };
        dots.forEach((btn) =>
          btn.addEventListener('click', () => {
            stop();
            go(parseInt(btn.dataset.go || '0', 10));
          })
        );
        document.addEventListener('visibilitychange', () => (document.hidden ? stop() : play()));
        mqlDesktop.addEventListener('change', () => applyActiveRatio(i));
        addEventListener('resize', () => applyActiveRatio(i));
        if (toggle) {
          toggle.addEventListener('click', () => {
            const pressed = toggle.getAttribute('aria-pressed') === 'true';
            toggle.setAttribute('aria-pressed', String(!pressed));
            !pressed ? stop() : play();
          });
        }
        applyActiveRatio(0);
        play();
      }
      function initAll() {
        $$('.rh-hero[data-component="hero"]').forEach(init);
      }
      document.addEventListener('DOMContentLoaded', initAll);
      document.addEventListener('shopify:section:load', (e) => {
        const root = e.target.querySelector('.rh-hero[data-component="hero"]');
        if (root) init(root);
      });
    })();
  
  } catch(e) { console.error(e); }
})();
})();
